module.exports = __webpack_public_path__ + "img/logo.663ad188.png";